import React, { Suspense, lazy } from 'react';
import PrivateRoute from "../../routes/PrivateRoute";
import PublicRoute from "../../routes/PublicRoute";
import { Spinner } from '../Common/Spinner';
const UserRegistrationList = lazy(() => import('./UserRegistrationList'));
const UserRegistrationForm = lazy(() => import('./UserRegistrationForm'));
const UserRegInstructionPage = lazy(() => import('./UserRegInstructionPage'));

const UserRegistrationRoute = (props) => (
  <Suspense fallback={<Spinner/>}>
    <PrivateRoute path="/list/user/registration/:organization_id" 
      searchString={props.searchString} 
      component={UserRegistrationList} exact />
    <PublicRoute path="/registration/user/:form_id/:organization_id" component={UserRegistrationForm} exact />
    <PublicRoute path="/user/registration/instruction/:organization_id" component={UserRegInstructionPage} exact />
  </Suspense>
)

export default UserRegistrationRoute;